"use client";
import { CashbackTypes } from "@/api/cashback";
import { getWheelApi } from "@/api/cashWheel";
import { useRouter } from "@/i18n/routing";
import { useGlobalNoticeStore } from "@/stores/useGlobalNoticeStore";
import { server } from "@/utils/client";
import { useRequest } from "ahooks";
import { Badge, Toast } from "antd-mobile";
import { useTranslations } from "next-intl";
import { FC } from "react";
import "./style.scss";

/**
 * @description 列表组件
 * @param {string} type 使用类型
 * @param {(params: any) => void} callbackFun 回调方法
 */
export interface ItemComProps {
    type?: string;
}
const getCashBackApi = async () => {
    return server
        .request<CashbackTypes>({
            url: "/v1/api/front/activity_cash",
            method: "post",
        })
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            return {
                rules: [],
                last_period: { end_time: 0, start_time: 0 },
                next_period: {
                    end_time: 0,
                    start_time: 0,
                },
                amount: 0,
                bet: 0,
                status: "expired",
            };
        });
};

const ItemCom: FC<ItemComProps> = ({ type = "login" }) => {
    const t = useTranslations("ProfilePage");
    const tall = useTranslations();
    const router = useRouter();
    const { unread, userUnread } = useGlobalNoticeStore((state) => ({
        unread: state.unread,
        userUnread: state.userUnred,
    }));
    const { data: cashback } = useRequest<any, any>(getCashBackApi, {
        pollingErrorRetryCount: 1,
    });

    const max = cashback?.rules.reduce(
        (acc: any, item: any) => (acc > item.cashback ? acc : item.cashback),
        0
    );
    const links = [
        // { label: "gratis", desc: "gratisDesc", icon: "", url: "/", content: null },
        {
            label: t("company"),
            desc: "",
            icon: "icon-huo",
            color: "#ff9b23",
            url: "/affiliate/summary",
            content: null,
        },
        {
            label: t("pray"),
            desc: "",
            icon: "icon-mianfei",
            color: "#16b257",
            url: "/cashWheel",
            content: null,
        },
        {
            label: t("cashback", { max: max }),
            desc: "",
            icon: "icon-qiandai",
            color: "#ff9b23",
            url: "/cashback",
            content: null,
        },
        {
            label: t("gamblingBets"),
            desc: "",
            color: "#16b257",
            icon: "icon-fuzhiwendang",
            url: "/betrecord",
            content: null,
        },
        {
            label: t("transactions"),
            desc: "",
            color: "#069eff",
            icon: "icon-jiaoyi",
            url: "/transactions",
            content: null,
        },
        {
            label: t("message"),
            desc: "",
            icon: "icon-xiaoxi3-copy",
            color: "#00f6ff",
            url: "/notification",
            content: unread || userUnread ? Badge.dot : null,
        },
        {
            label: tall("HomePage.Contante"),
            desc: "",
            icon: "icon-dakaixinxi",
            color: "#00f6ff",
            url: "/concat",
            content: unread || userUnread ? Badge.dot : null,
        },
    ];
    const routerHandler = (item: any) => {
        if (item.url === "/cashWheel") {
            getWheelApi().then((res) => {
                if (!Array.isArray(res.data) && !!res.data.activities) {
                    router.push(item.url);
                } else {
                    Toast.show("The event is not open");
                }
            });
        } else {
            router.push(item.url);
        }
    };

    return (
        <div className="itemCom-box">
            {links.map((item, index) => (
                <div className={`box-item`} onClick={() => routerHandler(item)} key={index}>
                    <div className={`${item.desc ? "box-item__left" : ""}`}>
                        <Badge content={item.content}>
                            <div className="content">
                                <i
                                    className={`iconfont ${item.icon}`}
                                    style={{ color: item.color, fontSize: "16px" }}
                                ></i>
                                {item.label}
                            </div>
                            {item.desc && <p className={"desc"}>{t(item.desc)}</p>}
                        </Badge>
                    </div>

                    <div>
                        <span className="iconfont icon-xiangyou1"></span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ItemCom;
